export function sketch() {

    const canvas = document.getElementById("canvas-drawing");
    const ctx = canvas.getContext("2d");

    let isDrawing = true;
    //let colors = ["#F291CB", "#DF91F2", "#F2D091"]
    let r, g, b, a;
    r = 242;
    g = 145;
    b = 203;
    a = 100;
    let color =`rgba(${r},${g},${b},${a})`;

    function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    }
    resize();
    window.addEventListener("resize", resize);

    let lastPos = { x: null, y: null };

    document.removeEventListener("mousemove", drawHandler);
    document.removeEventListener("click", toggleDraw);

    function toggleDraw(event) {
        if (event.button === 0) {
            isDrawing = !isDrawing;
        }
    }
    function drawHandler(event) {
        const x = event.clientX;
        const y = event.clientY;

        if (lastPos.x !== null && lastPos.y !== null && isDrawing) {
            ctx.beginPath();
            ctx.lineWidth = 0.5;
            ctx.lineCap = "round";
            ctx.strokeStyle = color;
            ctx.moveTo(lastPos.x, lastPos.y);
            ctx.lineTo(x, y);
            ctx.stroke();
        }
        lastPos = { x, y };
    }

    // document.addEventListener("click", toggleDraw);
    document.addEventListener("mousemove", drawHandler);
}

